import { z } from 'zod';

export enum ContentSectionContentType {
    PLAIN_TEXT = 'PLAIN_TEXT',
    RICH_TEXT = 'RICH_TEXT',
    MARKDOWN = 'MARKDOWN',
    IMAGE_ATTACHMENT = 'IMAGE_ATTACHMENT',
    VIDEO_ATTACHMENT = 'VIDEO_ATTACHMENT',
    VIDEO_URL = 'VIDEO_URL',
}

export const ContentSectionContentTypeSchema = z.enum(ContentSectionContentType);
